import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from 'react';

// import Header from "./componets/Header";
// import Footer from "./componets/Footer";
import Home from "./pages/Home";
import Service from "./pages/Service";
import About from "./pages/About";
import Resource from "./pages/Resource";
import EventListing from "./pages/EventListing";
import FutureEvents from "./pages/FutureEvents";
import AOS from "aos";
import Contact from "./pages/Contact";
import Media from "./pages/Media";
import FAQ from "./pages/FAQ";
import PageNotFound from "./pages/404"
// import Lorem from "./pages/Lorem";
// import Search from "./pages/Search";



// Import ScrollToTop
import ScrollToTop from "./ScrollToTop";



function App() {



  useEffect(() => {
    localStorage.setItem('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InRlc3R1c2VyIiwibmJmIjoxNzM2MjM5ODA3LCJleHAiOjE3MzYyNDM0MDcsImlhdCI6MTczNjIzOTgwNywiaXNzIjoiR1JTRl9BRE1JTiIsImF1ZCI6IlVTRVIifQ.vGWxyHq_Om4T6ysmgejF535tXh48tir5PDMye18zU_U');
    AOS.init(
      { once: true, }
    );
  }, []);


  return (
    <>
  
      {/* <Header /> */}
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route index element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/resource" element={<Resource />} />
          <Route path="/service" element={<Service />} />
          <Route path="/event-listing" element={<EventListing />} />
          <Route path="/future-events" element={<FutureEvents />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/media" element={<Media />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/404" element={<PageNotFound />} />
          {/* Wildcard route for unmatched paths */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>

      {/* <Footer /> */}
   
    
    </>
  );
}

export default App;
